var render = function() {
  var this$1 = this
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Layout",
    {
      attrs: {
        hasChangedData: _vm.hasChangedData,
        openModalChangeCountry: _vm.isOpenModalChangeCountry
      },
      on: {
        "update:openModalChangeCountry": function($event) {
          _vm.isOpenModalChangeCountry = $event
        },
        "update:open-modal-change-country": function($event) {
          _vm.isOpenModalChangeCountry = $event
        },
        confirmChangeFlag: _vm.handleConfirmChangeFlag
      }
    },
    [
      _c("section", { staticClass: "content ep__main_content pt-80" }, [
        _c(
          "div",
          { staticClass: "container", attrs: { "data-form-container": "" } },
          [
            _c(
              "div",
              { staticClass: "tab-content", attrs: { id: "myTabContent" } },
              [
                _c("FloatingError", {
                  attrs: { floatingErrors: _vm.floatingErrors }
                }),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade show active",
                    attrs: { id: "createPO", role: "tabpanel" }
                  },
                  [
                    _c("div", { staticClass: "content__title" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            this.getDisplayText("createPOPage_poTitleText")
                          ) +
                          " "
                      )
                    ]),
                    _c("PayerInformationForm", {
                      attrs: {
                        countryCode: _vm.countryCode,
                        companyName: _vm.companyName,
                        email: _vm.email,
                        contactNumber: _vm.contactNumber,
                        errors: _vm.msg,
                        contactInfo: _vm.countryContact,
                        readonlyMode: _vm.readonlyMode
                      },
                      on: {
                        "update:companyName": function($event) {
                          _vm.companyName = $event
                        },
                        "update:company-name": function($event) {
                          _vm.companyName = $event
                        },
                        "update:email": function($event) {
                          _vm.email = $event
                        },
                        "update:contactNumber": function($event) {
                          _vm.contactNumber = $event
                        },
                        "update:contact-number": function($event) {
                          _vm.contactNumber = $event
                        },
                        companyNameBlur: _vm.validateCompanyName,
                        emailBlur: _vm.validateEmail,
                        contactNumberBlur: _vm.validateContactNumber,
                        contactNumberKeypress: _vm.restrictOnlyNumber,
                        switchCountryContact: _vm.setCountryContact
                      }
                    }),
                    this.country
                      ? _c(
                          "div",
                          { staticClass: "d-flex justify-content-end ml-auto" },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "mr-8",
                                attrs: {
                                  "data-testid": "linkDownload",
                                  href: _vm.getDownloadLinkTemplate,
                                  target: "_blank",
                                  disabled: _vm.readonlyMode
                                }
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn p-8-12 btn__up-down btn--sm-scr",
                                    attrs: {
                                      type: "button",
                                      "data-toggle": "",
                                      "data-target": "#downloadTemplate",
                                      disabled: _vm.readonlyMode
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "mr-8",
                                      class: {
                                        "prevent-pointer-events":
                                          _vm.readonlyMode
                                      },
                                      attrs: {
                                        src: require("@static/img/download.svg"),
                                        alt: "download"
                                      }
                                    }),
                                    _vm._v(" Download template ")
                                  ]
                                )
                              ]
                            ),
                            _c("batch-upload", {
                              attrs: { isDisable: _vm.readonlyMode },
                              on: { bl_list_update: _vm.blListDataHandling }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "po-content" }, [
                      _c(
                        "div",
                        {
                          staticClass: "content__frame__header br-bt mb-8 pb-8"
                        },
                        [
                          _c("div", { staticClass: "row m-0" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-4 col-lg-4 p-0" },
                              [
                                _c("div", { staticClass: "d-flex" }, [
                                  _c("div", { staticClass: "ordinal-no" }, [
                                    _c(
                                      "label",
                                      { staticClass: "form__label mb-0" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            this.getDisplayText(
                                              "createPOPage_poContent_po_label_BillOfLadingNo"
                                            )
                                          ) + " "
                                        ),
                                        _c("br"),
                                        _vm.countryCode === "id" ||
                                        _vm.countryCode === "th"
                                          ? _c("span", [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "form__label-break-line"
                                                },
                                                [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        this.getDisplayText(
                                                          "createPOPage_poContent_po_label_Maximum"
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _vm._v(
                                                " per " +
                                                  _vm._s(
                                                    this.getDisplayText(
                                                      "createPOPage_poContent_po_label"
                                                    )
                                                  ) +
                                                  ") "
                                              )
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                " (" +
                                                  _vm._s(
                                                    this.getDisplayText(
                                                      "createPOPage_poContent_po_label_Maximum"
                                                    )
                                                  ) +
                                                  " per " +
                                                  _vm._s(
                                                    this.getDisplayText(
                                                      "createPOPage_poContent_po_label"
                                                    )
                                                  ) +
                                                  ") "
                                              )
                                            ])
                                      ]
                                    )
                                  ])
                                ])
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-4 col-lg-4 form__label-align-bottom pl-0"
                              },
                              [
                                _c("div", { staticClass: "row m-0" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-5 col-lg-4 p-0" },
                                    [
                                      _c("div", { staticClass: "pl-32" }, [
                                        _c(
                                          "label",
                                          { staticClass: "form__label mb-0" },
                                          [_vm._v("Currency")]
                                        )
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-7 col-lg-8 p-0" },
                                    [
                                      _c("div", { staticClass: "text-right" }, [
                                        _c(
                                          "label",
                                          { staticClass: "form__label mb-0" },
                                          [_vm._v("Amount")]
                                        )
                                      ])
                                    ]
                                  )
                                ])
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-4 col-lg-4 form__label-align-bottom pr-0"
                              },
                              [
                                _c("div", [
                                  _c(
                                    "label",
                                    { staticClass: "form__label mb-0" },
                                    [_vm._v("Remark")]
                                  )
                                ])
                              ]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._l(_vm.blList, function(bl, index) {
                      return _c(
                        "div",
                        {
                          key: bl.no,
                          staticClass: "po-content",
                          attrs: { "data-testid": "bl-row" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content__frame createpo__page mb-8 p-24"
                            },
                            [
                              _c("div", { staticClass: "row m-0" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-md-4 col-lg-4 p-0" },
                                  [
                                    _c("div", { staticClass: "row ml-0" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "numerical-order-oney align-items-center txt-black pl-0 pr-0 d-flex"
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "numerical-order" },
                                            [_vm._v(_vm._s(index + 1 + "."))]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "form__txtCurrency"
                                            },
                                            [_vm._v("ONEY")]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "col d-flex w-100" },
                                        [
                                          _c("bl-input", {
                                            staticClass:
                                              "form__control uppercase__input",
                                            class: {
                                              "error-controls": !!bl.numberError,
                                              "disable-color-input":
                                                _vm.readonlyMode
                                            },
                                            style: [
                                              bl.numberError
                                                ? {
                                                    border:
                                                      "1px solid #FF0000 !important",
                                                    background:
                                                      "#F5DBDC !important",
                                                    "box-sizing": "border-box",
                                                    "border-radius": "5px",
                                                    "-webkit-box-shadow":
                                                      "0 0 0 100px #F5DBDC inset !important"
                                                  }
                                                : {}
                                            ],
                                            attrs: {
                                              type: "text",
                                              value: bl.number,
                                              name: "number",
                                              placeholder: _vm.getDisplayText(
                                                "createPOPage_poInforContent_numberInput_placeHolder"
                                              ),
                                              maxlength: "16",
                                              "aria-label": "BL number",
                                              disabled: _vm.readonlyMode,
                                              "data-testid": "blnumber",
                                              "data-input-id": index + 1 + "_1"
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.handleBlNumberInputBlur(
                                                  bl
                                                )
                                              },
                                              change: function($event) {
                                                _vm.setBLListByField(
                                                  index,
                                                  "number",
                                                  $event.toUpperCase()
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "w-100" }),
                                      _c("div", {
                                        staticClass:
                                          "numerical-order-oney align-items-center pr-16 txt-black pl-0 d-flex"
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "col d-flex w-100" },
                                        [
                                          bl.numberError
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "content__feedback",
                                                  attrs: {
                                                    "data-testid":
                                                      "bl-number-error-" +
                                                      index,
                                                    "data-input-id-error":
                                                      index + 1 + "_1"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        bl.numberError
                                                          ? bl.numberError
                                                              .message
                                                          : ""
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ])
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-md-4 col-lg-4 pl-0" },
                                  [
                                    _c("div", { staticClass: "row m-0" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-5 col-lg-4 p-0"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center h-100 form__txtCurrency"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "w-100 pl-32",
                                                  class: {
                                                    "disable-color-input--pink":
                                                      _vm.readonlyMode
                                                  },
                                                  attrs: {
                                                    "aria-label": "BL currency"
                                                  }
                                                },
                                                [_vm._v(_vm._s(bl.currency))]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-7 col-lg-8 p-0"
                                        },
                                        [
                                          _c("bl-input", {
                                            staticClass:
                                              "form__control form__txtAmount po-amount",
                                            class: {
                                              "error-controls": !!bl.amountError,
                                              "disable-color-input--pink":
                                                _vm.readonlyMode
                                            },
                                            attrs: {
                                              type: "text",
                                              value: bl.amount,
                                              name: "amount",
                                              placeholder:
                                                "Please input amount",
                                              "aria-label": "BL amount",
                                              maxlength:
                                                _vm.maxLengthAmountDisplay,
                                              disabled: _vm.readonlyMode,
                                              "data-testid": "blamount",
                                              "data-input-id": index + 1 + "_2"
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.validateBLAmount(bl)
                                              },
                                              keydown:
                                                _vm.restrictOnlyAmountOnKeydown,
                                              keypress:
                                                _vm.restrictOnlyAmountOnKeypress,
                                              change: function($event) {
                                                return _vm.setBLListByField(
                                                  index,
                                                  "amount",
                                                  $event
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "w-100" }),
                                      _c("div", {
                                        staticClass: "col-md-5 col-lg-4 p-0"
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-7 col-lg-8 p-0"
                                        },
                                        [
                                          bl.amountError
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "content__feedback",
                                                  attrs: {
                                                    "data-testid":
                                                      "bl-amount-error-" +
                                                      index,
                                                    "data-input-id-error":
                                                      index + 1 + "_2"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        bl.amountError
                                                          ? bl.amountError
                                                              .message
                                                          : ""
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ])
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-md-4 col-g-4 pr-0" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex flex-column" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "d-flex" },
                                          [
                                            _c("bl-input", {
                                              staticClass: "form__control",
                                              class: {
                                                "error-controls":
                                                  bl.remarkError,
                                                "disable-color-input":
                                                  _vm.readonlyMode
                                              },
                                              attrs: {
                                                type: "text",
                                                value: bl.remark,
                                                placeholder:
                                                  "Please input, if any",
                                                maxlength: "2000",
                                                "aria-label": "BL remark",
                                                disabled: _vm.readonlyMode,
                                                "data-testid": "blremark",
                                                "data-input-id":
                                                  index + 1 + "_3"
                                              },
                                              on: {
                                                blur: function($event) {
                                                  return _vm.validateBLRemark(
                                                    bl
                                                  )
                                                },
                                                change: function($event) {
                                                  return _vm.setBLListByField(
                                                    index,
                                                    "remark",
                                                    $event
                                                  )
                                                }
                                              }
                                            }),
                                            _c(
                                              "ep-icon-button",
                                              {
                                                staticClass:
                                                  "d-flex form__delete b-row-remove-icon p-0",
                                                attrs: {
                                                  tabindex: "-1",
                                                  "data-testid":
                                                    "bl-remove-button",
                                                  disabled: _vm.readonlyMode
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeBl(index)
                                                  }
                                                }
                                              },
                                              [_c("delete-icon")],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        bl.remarkError
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "content__feedback",
                                                attrs: {
                                                  "data-testid":
                                                    "bl-remark-error-" + index,
                                                  "data-input-id-error":
                                                    index + 1 + "_3"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      bl.remarkError
                                                        ? bl.remarkError.message
                                                        : ""
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    }),
                    _c("div", { staticClass: "d-flex flex-column mb-48" }, [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center" },
                        [
                          _c("EpAddRowButton", {
                            attrs: {
                              "data-testid": "bl-add-button",
                              isDisabled:
                                _vm.isDisableAddInvoiceBtn || _vm.readonlyMode,
                              addRowTitle: _vm.getDisplayText(
                                "component_epAddRowButton_text"
                              )
                            },
                            on: {
                              add: function($event) {
                                return _vm.addBl()
                              }
                            }
                          }),
                          _c(
                            "span",
                            {
                              staticClass: "text-maximum-records ml-16",
                              class: { "opacity-60": _vm.readonlyMode }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getDisplayText(
                                    "createPOPage_max_records_label"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm.isDisableAddInvoiceBtn
                        ? _c(
                            "div",
                            {
                              staticClass: "content__feedback",
                              attrs: { "data-testid": "error-max-bl" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getDisplayText(
                                    "createPOPage_poContent_maxBLsRecord_errorMsg"
                                  )
                                )
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _c("div", { staticClass: "content__frame mb-16" }, [
                      _c("div", { staticClass: "row ml-0 mr-0" }, [
                        _c("div", { staticClass: "col-lg-4 col-5 pl-0 pr-0" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content__address p-24 h-100 d-flex flex-column"
                            },
                            [
                              _c("label", { staticClass: "mb-16 txt-14" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "txt-16-b txt-black text-uppercase"
                                  },
                                  [_vm._v("Receivable office")]
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v("(Payment will be made to below office)")
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "align-items-end justify-content-end mt-auto"
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "txt-16-b txt-pink text-uppercase mb-0",
                                      attrs: {
                                        "data-testid": "receivable-office-name"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          this.defaultReceivableOffice
                                            .officeName || ""
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "label",
                                    { staticClass: "txt-black mb-0" },
                                    [
                                      _vm._v("Address: "),
                                      _c("span", {
                                        staticClass: "txt-gray",
                                        attrs: {
                                          "data-testid":
                                            "receivable-office-address"
                                        },
                                        domProps: {
                                          innerHTML: _vm._s(
                                            this.defaultReceivableOffice
                                              .address || ""
                                          )
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-lg-8 col-7 d-flex flex-column total-area"
                          },
                          [
                            _c("TotalAmount", {
                              attrs: {
                                totalAmount: _vm.totalAmount,
                                countryCode: _vm.countryCode,
                                errorFn: function(max, exceed, currency) {
                                  return _vm.getTextByCountry(
                                    this$1.countryCode,
                                    "createPOpage_maxAmount_uploadFile_errorMsg_reachedMax",
                                    [max, exceed, currency]
                                  )
                                }
                              }
                            }),
                            _c("div", { staticClass: "pt-24" }, [
                              _c("div", { staticClass: "row d-flex" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xxl-7 justify-content-end align-items-end"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.createdPONumber,
                                          expression: "createdPONumber"
                                        }
                                      ],
                                      staticClass: "auto-field",
                                      class: {
                                        "po-number-auto-field": _vm.readonlyMode
                                      },
                                      attrs: {
                                        type: "text",
                                        placeholder: this.getDisplayText(
                                          "createPOPage_poNumberAutoGenerate_textbox_placeHolder"
                                        ),
                                        disabled: ""
                                      },
                                      domProps: { value: _vm.createdPONumber },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.createdPONumber =
                                            $event.target.value
                                        }
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xxl-5 d-flex justify-content-end align-items-end"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex h-100" },
                                      [
                                        _vm.readonlyMode
                                          ? _c(
                                              "ep-button",
                                              {
                                                staticClass:
                                                  "mr-16 btn-size submit-button",
                                                attrs: {
                                                  "data-testid":
                                                    "proceed-to-pay-button"
                                                },
                                                on: {
                                                  click:
                                                    _vm.handleProceedToPayButtonClicked
                                                }
                                              },
                                              [_vm._v(" Proceed to Pay ")]
                                            )
                                          : _c(
                                              "ep-button",
                                              {
                                                staticClass:
                                                  "mr-16 submit-button",
                                                attrs: {
                                                  "data-testid":
                                                    "save-and-proceed-to-pay-button",
                                                  disabled: !_vm.canProceedToPay
                                                },
                                                on: {
                                                  click:
                                                    _vm.handleSaveAndProceedToPayButtonClick
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " Save and Proceed to Pay "
                                                )
                                              ]
                                            ),
                                        _c(
                                          "ep-button",
                                          {
                                            staticClass:
                                              "btn btn--main btn--blue btn--sm-scr save-btn submit-button",
                                            class:
                                              ((_obj = {}),
                                              (_obj["btn--blue--disable"] =
                                                !_vm.canProceedToPay ||
                                                _vm.readonlyMode),
                                              _obj),
                                            attrs: {
                                              type: "button",
                                              disabled:
                                                !_vm.canProceedToPay ||
                                                _vm.readonlyMode,
                                              "data-testid":
                                                "save-and-email-button"
                                            },
                                            on: {
                                              click:
                                                _vm.handleSaveAndEmailButtonClick
                                            }
                                          },
                                          [_vm._v(" Save and Email ")]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "modal fade",
                                        attrs: {
                                          id: "saveModalOnCreate",
                                          tabindex: "-1",
                                          "aria-labelledby": "saveModal",
                                          "aria-hidden": "true"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "modal-dialog modal-dialog-centered"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "modal-content" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "modal-body p-32"
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "txt-center mb-24"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              this.getDisplayText(
                                                                "createPOPage_poCreation_successfullyPopup_text"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "txt-pink txt-bold"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.createdPONumber
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " has been created and sent to your email. Do you want to create a new one?"
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      { staticClass: "row" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "col-6"
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "btn btn--md btn--pink btn--sm-scr w-100",
                                                                attrs: {
                                                                  href: "#",
                                                                  type: "button"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Create a New One"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "col-6"
                                                          },
                                                          [
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "btn btn--md btn--blue btn--sm-scr w-100",
                                                                attrs: {
                                                                  type:
                                                                    "button",
                                                                  "data-dismiss":
                                                                    "modal"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "View Details"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "modal fade",
                                        attrs: {
                                          id: "saveModalOnCreateAgain",
                                          tabindex: "-1",
                                          "aria-labelledby": "saveModal",
                                          "aria-hidden": "true"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "modal-dialog modal-dialog-centered"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "modal-content" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "modal-body p-32 d-flex flex-column align-items-center"
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "txt-center mb-24"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            this.getDisplayText(
                                                              "createPOPage_poCreation_sentToEmailSuccess_text"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn--md btn--pink btn--sm-scr btn--md",
                                                        attrs: {
                                                          type: "button",
                                                          "data-dismiss":
                                                            "modal"
                                                        }
                                                      },
                                                      [_vm._v("OK")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ])
                          ],
                          1
                        )
                      ])
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "modal fade",
                        attrs: {
                          id: "saveModal",
                          tabindex: "-1",
                          role: "dialog",
                          "aria-labelledby": "saveModal",
                          "aria-hidden": "true"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "modal-dialog modal-dialog-centered",
                            attrs: { role: "document" }
                          },
                          [
                            _c("div", { staticClass: "modal-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "modal-body d-flex flex-column align-items-center m-auto mt-32"
                                },
                                [
                                  _c("img", {
                                    staticClass: "img-128",
                                    attrs: {
                                      src: require("@static/img/Email.svg"),
                                      alt: ""
                                    }
                                  }),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "txt-center txt-24 txt-black mt-32"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          this.getDisplayText(
                                            "createPOPage_saveAndEmail_button_notice"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "modal-footer d-flex align-self-center bd-t-none mb-32"
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn--pd70 btn--pink",
                                      attrs: {
                                        type: "button",
                                        "data-bs-dismiss": "modal"
                                      }
                                    },
                                    [_vm._v("OK")]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ],
                  2
                )
              ],
              1
            )
          ]
        )
      ]),
      _c("Loading", { attrs: { isRequesting: _vm.isCreatingPO } }),
      _c("DialogPOCreated", {
        attrs: {
          countryCode: _vm.countryCode,
          isOpen: _vm.isOpenCreatedPODialog,
          poNumber: _vm.createdPONumber || ""
        },
        on: {
          createNewOne: _vm.handleCreateNewOne,
          viewDetails: _vm.activeViewOnlyMode
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }